import { Doughnut } from 'react-chartjs-2';
import {
  Box,
} from '@mui/material';
// import BasicMenu from 'src/components/common/BasicMenu';
import PropTypes from "prop-types";
import { useRef } from 'react';

const CustomDoughnut = ({refreshBarChart, ...props}) => {
  const chartRef = useRef(null);
  var baseImg;
//   const theme = useTheme();
  const gender = {
    labels: props.labels && props.labels.length ? props.labels : [
      'Total Employees',
    ],
    datasets: [{
      data: props.data && props.data.length ? props.data : [props.count || 0],
      backgroundColor: props.backgroundColor && props.backgroundColor.length ? props.backgroundColor : [
        '#1778f2',
      ],
      borderWidth: 0,
      hoverOffset: 4
    }]
  }
  const options = {
    animations: false,
    cutout: 25,
    radius: '85%',
    maintainAspectRatio: false,
    responsive: true,
    // layout: { padding: 0 }, //default
    plugins: {
      legend: {
        display: false, //default
        // labels: {
        //   boxWidth: 25
        // }
      },
      title: {
        display: true,
        text: props.title || '',
        color: '#050a4e',
        font: {
            weight: 'normal'
        }
      },
      subtitle: {
        display: true,
        text: 'Custom Chart Subtitle'
      }
    }
  };

  return (
        <Box
          sx={{
            height: '100%',
            width: '100%'
            // minWidth: '100%',
            // maxWidth: '1200px'
          }}
        //   className={!props.data ? 'display-center' : ''}
        >
          <Doughnut
            // ref = {chartRef}
            data={gender}
            options={options}
          />
        </Box>
    //   {/* </CardContent>
    // </Card> */}
  );
};

CustomDoughnut.propTypes = {
//   refreshBarChart: PropTypes.func,
//   data: PropTypes.object
};

export default CustomDoughnut;
